module.exports = __webpack_public_path__ + "fo.svg?4bd8156d13fe51d871b78678438f8827";